import React from 'react';
import "./NotAllowed.scss";
import { useNavigate } from 'react-router-dom';
import notAllowedImg from "../../assets/images/not-allowed.svg";

const NotAllowed = () => {
    const navigate = useNavigate();

    return (
        <div className="not-allowed-container">
            <div className="not-allowed-image">
                <img src={notAllowedImg} alt="Access Denied" height={250}/>
            </div>
            <div className="not-allowed-text">
                <h1>403 - Access Denied</h1>
                <h2>You don’t have permission to view this page</h2>
                <p>The page you're trying to access has restricted access.</p>
                <p>Please contact your system administrator for more details.</p>
                <button className="back-home" onClick={() => navigate('/')}>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default NotAllowed;